import { Component, inject, computed, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import { BrnPopoverImports, BrnPopover } from '@spartan-ng/brain/popover';
import { NotificationStateService } from '../../../core/services/notification-state.service';
import { Notification } from '../../../core/models/notification.models';

@Component({
  selector: 'app-notification-bell',
  imports: [HlmPopoverImports, BrnPopoverImports],
  templateUrl: './notification-bell.component.html',
  host: { class: 'block' },
})
export class NotificationBellComponent {
  private readonly state = inject(NotificationStateService);
  private readonly router = inject(Router);
  private readonly popover = viewChild(BrnPopover);

  readonly notifications = this.state.notifications;
  readonly unreadCount = this.state.unreadCount;
  readonly hasUnread = computed(() => this.unreadCount() > 0);

  onNotificationClick(notification: Notification): void {
    if (!notification.isRead) {
      this.state.markAsRead(notification.id);
    }
    const route = this.buildRoute(notification);
    if (route) {
      this.popover()?.close();
      this.router.navigate(route);
    }
  }

  markAllRead(): void {
    this.state.markAllRead();
  }

  deleteNotification(event: MouseEvent, notification: Notification): void {
    event.stopPropagation();
    this.state.deleteNotification(notification.id);
  }

  typeIcon(type: string): 'success' | 'warning' | 'error' | null {
    switch (type) {
      case 'Success': return 'success';
      case 'Warning': return 'warning';
      case 'Error': return 'error';
      default: return null;
    }
  }

  private buildRoute(notification: Notification): string[] | null {
    if (notification.relatedEntityType === 'RfUpload' && notification.relatedEntityId != null) {
      return ['/dashboard', 'submissions', notification.relatedEntityId.toString()];
    }
    return null;
  }

  timeAgo(dateString: string): string {
    const now = Date.now();
    const date = new Date(dateString).getTime();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  }
}
